import { render, staticRenderFns } from "./EditorVideo.vue?vue&type=template&id=ca634fbc&scoped=true&"
import script from "./EditorVideo.vue?vue&type=script&lang=js&"
export * from "./EditorVideo.vue?vue&type=script&lang=js&"
import style0 from "./EditorVideo.vue?vue&type=style&index=0&id=ca634fbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca634fbc",
  null
  
)

export default component.exports